module.exports = __webpack_public_path__ + "img/book.046c7b6a.png";